import { useMemo } from 'react';
import type { Sample } from '../../simulation/types';
import { parseMarkup } from '../Markup';

const COLS: { key: keyof Sample; label: string; digits: number }[] = [
  { key: 't', label: '$t$ (s)', digits: 2 },
  { key: 'r', label: '$r$ (m)', digits: 3 },
  { key: 'z', label: '$z$ (m)', digits: 3 },
  { key: 'v', label: '$v$ (m/s)', digits: 3 },
  { key: 'a', label: '$a$ (m/s²)', digits: 3 },
  { key: 'e', label: '$e$ (m)', digits: 4 },
  { key: 'Tcmd', label: '$T_{cmd}$ (N)', digits: 2 },
  { key: 'T', label: '$T$ (N)', digits: 2 },
  { key: 'd', label: '$d$ (N)', digits: 2 },
];

/** Numeric data table: one row every 0.1 s of simulated time. */
export function DataTable({ trace, version }: { trace: Sample[]; version: number }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const rows = useMemo(() => trace.filter((s) => Math.abs(s.t * 10 - Math.round(s.t * 10)) < 1e-6), [version]);
  if (!rows.length) return <p className="small muted">No samples yet.</p>;
  return (
    <div className="table-scroll" tabIndex={0} role="region" aria-label="Recorded samples">
      <table className="data">
        <caption className="sr-only">Recorded samples every 0.1 s</caption>
        <thead>
          <tr>
            {COLS.map((c) => (
              <th key={c.key} scope="col">
                {parseMarkup(c.label, c.key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((s) => (
            <tr key={s.t}>
              {COLS.map((c) => (
                <td key={c.key}>{(s[c.key] as number).toFixed(c.digits)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
